// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const CardWrapper = styled.div<{
  isDark: boolean;
  inverse?: boolean;
  hover: string;
}>(
  ({ theme, isDark, inverse, hover }) => css`
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.white
    };
    box-shadow: ${
      isDark
        ? 'none'
        : '0px 0px 12px rgba(227, 228, 229, 0.5), 0px 0px 4px rgba(187, 188, 191, 0.16)'
    };
    height: 224px;
    .subtitle {
      color: ${isDark ? '#9DA0BB' : '#73757A'};
    }
    picture {
      position: relative !important;
      display: flex;
      align-items: center;
      justify-content: ${inverse ? 'flex-start' : 'flex-end'};
      max-height: 224px;
      img {
        max-height: 224px;
      }
    }
    :hover {
      outline: 1px solid ${hover || 'transparent'};
      box-shadow: ;
      box-shadow: ${
        isDark
          ? 'none'
          : '0px 16px 24px rgba(227, 228, 229, 0.24), 0px 0px 16px rgba(187, 188, 191, 0.32)'
      };
      cursor: pointer;
    }
  `,
);
